/** @format **/
import { ProductType } from "interfaces/plan";

export const CrashReporting = 'Crash Reporting';

export const RealUserMonitoring = 'Real User Monitoring';

export const APM = 'APM';

export const Tracing = 'Tracing';

export const Platform = 'Platform';

export const UsageCapping = 'Usage Capping';

export const SingleSignOn = 'Single Sign On';

// Products with legacy SDK setup instructions.
export type SdkProductType = typeof CrashReporting | typeof RealUserMonitoring | typeof APM;

export type ProductTypes =
  | SdkProductType
  | typeof Tracing
  | typeof Platform
  | typeof UsageCapping
  | typeof SingleSignOn;

export const Products = {
  CrashReporting: CrashReporting,
  RealUserMonitoring: RealUserMonitoring,
  APM: APM,
  Tracing: Tracing,
  UsageCapping: UsageCapping,
  SingleSignOn: SingleSignOn
};

// FE Version of the `Mindscape.Raygun.Common.Interfaces.Models.ProductTypes`
export enum ProductTypesEnum {
  CrashReporting = 0,
  Pulse = 1,
  APM = 2,
  Tracing = 3,
  Platform = 10,
  AdditionalUser = 11,
  UsageCapping = 12,
  SingleSignOn = 13,
}

export function getProductType(productTypeEnum: ProductTypesEnum): ProductType {
  switch (productTypeEnum) {
    case ProductTypesEnum.Platform:
      return ProductType.PLATFORM;
    case ProductTypesEnum.CrashReporting:
      return ProductType.CRASH_REPORTING;
    case ProductTypesEnum.Pulse:
      return ProductType.RUM;
    case ProductTypesEnum.Tracing:
      return ProductType.TRACING;
    case ProductTypesEnum.APM:
      return ProductType.APM;
    case ProductTypesEnum.UsageCapping:
      return ProductType.USAGE_CAPPING;
    case ProductTypesEnum.SingleSignOn:
      return ProductType.SINGLE_SIGN_ON;
  }
}

export function productEnumToProduct(product: ProductTypesEnum): ProductTypes {
  switch (product) {
    case ProductTypesEnum.CrashReporting:
      return 'Crash Reporting';
    case ProductTypesEnum.Pulse:
      return 'Real User Monitoring';
    case ProductTypesEnum.Tracing:
      return 'Tracing';
    case ProductTypesEnum.APM:
      return 'APM';
    case ProductTypesEnum.Platform:
      return 'Platform';
    case ProductTypesEnum.UsageCapping:
      return 'Usage Capping';
    case ProductTypesEnum.SingleSignOn:
      return 'Single Sign On';
  }
}

export function productEnumToDisplayString(product: ProductTypesEnum, full: boolean = false) {
  switch (product) {
    case ProductTypesEnum.CrashReporting:
      return 'Crash Reporting';
    case ProductTypesEnum.Pulse:
      return 'Real User Monitoring';
    case ProductTypesEnum.Tracing:
      return 'Tracing';
    case ProductTypesEnum.APM:
      return full ? 'Raygun APM' : 'APM';
    case ProductTypesEnum.Platform:
      return 'Platform';
    case ProductTypesEnum.AdditionalUser:
      return 'User';
    case ProductTypesEnum.UsageCapping:
      return 'Usage Capping';
    case ProductTypesEnum.SingleSignOn:
      return 'Single Sign On';
  }
}

export function productEnumToUrlFriendlyString(
  product: ProductTypesEnum,
  lowercase: boolean = false,
) {
  let val: string = '';
  switch (product) {
    case ProductTypesEnum.CrashReporting:
      val = 'CrashReporting';
      break;
    case ProductTypesEnum.Pulse:
      val = 'Pulse';
      break;
    case ProductTypesEnum.Tracing:
      val = 'Tracing';
      break;
    case ProductTypesEnum.APM:
      val = 'APM';
      break;
    case ProductTypesEnum.Platform:
      val = 'Platform';
      break;
    case ProductTypesEnum.AdditionalUser:
      val = 'AdditionalUser';
      break;
    case ProductTypesEnum.UsageCapping:
      val = 'UsageCapping';
      break;
    case ProductTypesEnum.SingleSignOn:
      val = 'SingleSignOn';
      break;
  }
  return lowercase ? val.toLowerCase() : val;
}

export function stringToProductEnum(product: string): ProductTypesEnum {
  switch (product.replace(/\s/g, '').toLowerCase()) {
    case 'crashreporting':
      return ProductTypesEnum.CrashReporting;
    case 'realusermonitoring':
    case 'pulse':
      return ProductTypesEnum.Pulse;
    case 'tracing':
      return ProductTypesEnum.Tracing;
    case 'apm':
      return ProductTypesEnum.APM;
    case 'platform':
      return ProductTypesEnum.Platform;
    case 'additionaluser':
      return ProductTypesEnum.AdditionalUser;
    case 'usagecapping':
      return ProductTypesEnum.UsageCapping;
    case 'singlesignon':
      return ProductTypesEnum.SingleSignOn;
  }
}